import { render, staticRenderFns } from "./share-code.vue?vue&type=template&id=bee100d8&scoped=true"
import script from "./share-code.vue?vue&type=script&lang=js"
export * from "./share-code.vue?vue&type=script&lang=js"
import style0 from "./share-code.vue?vue&type=style&index=0&id=bee100d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee100d8",
  null
  
)

export default component.exports